<template>
  <v-app>

    <v-main class="main-content">
      <v-container>
          <!-- Filtro de precios menor que y mayor que -->
        <v-dialog v-model="dialogFiltro" max-width="420">
          <v-card class="rounded-lg elevation-10">
            <!-- Encabezado -->
            <v-card-title class="bg-blue-darken-4 text-white d-flex align-center">
              <v-icon class="mr-2">mdi-filter-cog</v-icon>
              <span class="text-h6 font-weight-medium">Filtrar y ordenar</span>
            </v-card-title>

            <!-- Contenido -->
            <v-card-text class="py-6 px-4">
              <!-- Switch de orden por precio -->
              <v-switch v-model="sortByPrice" color="primary" inset class="mb-4">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon small class="mr-1 text-primary"></v-icon>
                    <span> <strong>De menor a mayor</strong></span>
                  </div>
                </template>
              </v-switch>

              <!-- Select de marca -->
              <v-select
                v-model="selectedBrand"
                :items="brands"
                label="Filtrar por marca"
                clearable
                variant="outlined"
                color="primary"
                density="comfortable"
                class="mb-2"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-icon class="mr-2">mdi-store</v-icon>
                    <v-list-item-title>Marcas disponibles</v-list-item-title>
                  </v-list-item>
                  <v-divider class="my-1"></v-divider>
                </template>
              </v-select>
            </v-card-text>

            <!-- Acciones -->
            <v-card-actions class="justify-space-between align-center px-4 py-3 bg-white">
              <!-- Logo -->
              <img
                src="https://grupomv.mx/images/logos/1.png"
                alt="logo"
                width="100"
                height="30"
              />

              <!-- Botón aplicar -->
              <v-btn
                color="primary"
                variant="elevated"
                class="rounded-lg px-4 text-white text-capitalize"
                @click="applyFilters"
              >
                <v-icon class="mr-1">mdi-check</v-icon>
                Aplicar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Botón del carrito flotante -->
        <v-btn
          v-bind="props"
          @click="openCart"
          color="blue-darken-4"
          class="fixed-cart-btn text-white"
          elevation="4"
        >
          <v-icon left>mdi-cart-outline</v-icon>
          Ver Canasta ({{ totalCajas }})
        </v-btn>

        <br /><br />

        <!-- Productos -->

    <!-- 🔹 Carrusel horizontal de productos -->
<div class="products-scroll">
  <div
    v-for="product in filteredProducts"
    :key="product.id"
    class="product-item"
  >
    <v-card class="pa-4" variant="flat" style="width: 240px;">
      <v-row>
        <div class="d-flex align-center" style="position: relative">
          <div
            v-if="getProductQuantity(product) > 0"
            class="d-flex align-center mt-2"
          >
            <v-btn
              icon
              @click="decreaseQuantity(product)"
              variant="text"
              density="compact"
              color="orange-darken-1"
            >
              <v-icon>mdi-minus-circle</v-icon>
            </v-btn>

            <span
              class="px-2 text-caption font-weight-bold"
              style="font-size: 1.2em"
            >
              {{ getProductQuantity(product) }}
            </span>

            <v-btn
              icon
              size="42"
              @click="increaseQuantity(product)"
              density="compact"
              variant="text"
              color="blue-darken-4"
              :disabled="
                product.id_promocion
                  ? getProductQuantity(product) >= 5
                  : getProductQuantity(product) >= product.yfr_disponible
              "
            >
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </div>
        </div>
      </v-row>

      <v-row class="d-flex justify-center" style="position: relative">
        <v-col cols="9" style="position: relative">
          <v-img
            lazyloading
            :src="product.foto || 'default-image-url'"
            height="100px"
            class="rounded"
          />
          <v-icon
            color="blue-darken-4"
            size="42"
            v-ripple
            class="add-icon"
            style="
              position: absolute;
              top: 5px;
              right: 5px;
              background: white;
              border-radius: 50%;
              padding: 2px;
              cursor: pointer;
            "
            :disabled="
              product.id_promocion
                ? getProductQuantity(product) >= 1
                : getProductQuantity(product) >= product.yfr_disponible
            "
            @click="
              ((product.id_promocion && getProductQuantity(product) < 1) ||
                (!product.id_promocion &&
                  getProductQuantity(product) < product.yfr_disponible)) &&
                addToCart(product)
            "
            :class="{
              'v-icon--disabled': product.id_promocion
                ? getProductQuantity(product) >= 1
                : getProductQuantity(product) >= product.yfr_disponible,
            }"
            :style="
              getProductQuantity(product) > 0
                ? 'pointer-events: none; opacity: 0;'
                : ''
            "
          >
            mdi-plus-circle
          </v-icon>
        </v-col>
      </v-row>

      <div class="w-full text-center mt-4 p-3 space-y-1">
        <template v-if="product.id_promocion && product.promo_price">
          <div class="text-gray-500 line-through font-semibold">
            ${{ product.price }}
          </div>
          <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
            ${{
              (
                product.price -
                (product.price * product.promo_price) / 100
              ).toFixed(2)
            }}
          </div>
        </template>
        <template v-else>
          <div
            class="text-base sm:text-lg md:text-xl font-semibold text-blue-700"
          >
            ${{ product.price }}
          </div>
        </template>

        <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
          {{ product.nombre }}
        </div>

        <div class="text-xs sm:text-sm font-medium text-gray-400">
          SKU: {{ product.sku }}
        </div>

        <div
          v-if="product.id_promocion && product.promo_price"
          class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full"
        >
          Descuento {{ product.promo_price }}%
        </div>

        <div
          v-if="product.yfr_disponible <= 0"
          class="text-sm sm:text-base font-semibold text-red-500"
        >
          Agotado
        </div>
      </div>
    </v-card>
  </div>
</div>


        <!-- Diálogo del carrito -->
        <CartDialog v-model="cartDialog" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import CartDialog from "../Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
import { inject, computed } from "vue";

export default {
  name: "ExpressMV",
  components: {   CartDialog },
  setup() {
    // Inyectar el store del carrito
    const cartStore = inject("cartStore"); // Asegúrate de que 'cartStore' esté proporcionado globalmente

    // Usar los métodos del store global
    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const getProductQuantity = cartStore.getProductQuantity;
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });

    return {
      addToCart, // Usar el método global para agregar al carrito
      increaseQuantity, // Usar el método global para aumentar la cantidad
      decreaseQuantity, // Usar el método global para disminuir la cantidad
      getProductQuantity,
      totalCajas,
    };
  },
  data() {
    return {
      searchQuery: "",
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [], // Para múltiples valores
      selectedBrand: null,
      currentPage: 1,
      hasMoreProducts: true,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
    };
  },
  computed: {
    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
          ? this.selectedBrands.includes(product.sublinea)
          : true;

        return matchesSearch && matchesBrand;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {
    clearCart() {
      this.cart = []; // Vaciar el carrito
      localStorage.removeItem("cart"); // Limpiar el almacenamiento local
    },

    openCart() {
      this.cartDialog = true;
    },

    applyFilters() {
      this.dialogFiltro = false;
    },

    async fetchProducts(page = 1) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found, please login again");
          return;
        }
 
        const limit = 180;
        const offset = (page - 1) * limit;

        const cacheKey = `productos_cache_page_${page}`;
        const cacheTimestampKey = `${cacheKey}_timestamp`;
        const now = Date.now();
        const oneHour = 60 * 60 * 1000; // 60 minutos * 60 segundos * 1000 ms = 3,600,000 ms

        // Verificar si hay caché válida
        const cachedData = localStorage.getItem(cacheKey);
        const cachedTime = localStorage.getItem(cacheTimestampKey);

        if (cachedData && cachedTime && now - cachedTime < oneHour) {
          const data = JSON.parse(cachedData);

          if (data.length < limit) {
            this.hasMoreProducts = false;
          } else {
            this.hasMoreProducts = true;
          }

          this.products = [
            ...this.products,
            ...data.map((product) => ({
              ...product,
              price: product.price || 0,
            })),
          ];

          this.brands = [...new Set(this.products.map((p) => p.sublinea))];
          return;
        }

        // Si no hay caché o expiró, hacer la petición
        const response = await axios.get(
          "https:///100-ofertar",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              limit,
              offset,
            },
          }
        );

        if (response.data.length < limit) {
          this.hasMoreProducts = false;
        } else {
          this.hasMoreProducts = true;
        }

        // Guardar en caché
        localStorage.setItem(cacheKey, JSON.stringify(response.data));
        localStorage.setItem(cacheTimestampKey, now.toString());

        this.products = [
          ...this.products,
          ...response.data.map((product) => ({
            ...product,
            price: product.price || 0,
          })),
        ];

        this.brands = [...new Set(this.products.map((product) => product.sublinea))];
      } catch (error) {
        console.error("Error fetching products:", error.message);
      }
    },

    loadMoreProducts() {
      if (this.hasMoreProducts) {
        this.currentPage++;
        this.fetchProducts(this.currentPage);
      }
    },

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY; // Posición actual del scroll
      const bottomPosition = document.documentElement.offsetHeight; // Altura total del documento

      // Si el usuario está cerca del final de la página, cargar más productos
      if (scrollPosition >= bottomPosition - 100 && this.hasMoreProducts) {
        this.loadMoreProducts();
      }
    },
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.replace("/"); // Redirige y borra el historial
    }

    this.fetchProducts(); // Cargar la primera página de productos al montar el componente

    const saveCart = localStorage.getItem("cart");
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }

    // Agregar el evento de scroll
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Cambiado de beforeDestroy a beforeUnmount
    // Eliminar el evento de scroll al destruir el componente
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.main-content {
  padding-bottom: calc(env(safe-area-inset-bottom) + 150px) !important;
}

/* Carrusel horizontal de marcas */
.products-scroll {
  display: flex;
  overflow-x: auto;
  gap: 0px;
  padding: 0px 0;
  scroll-snap-type: x mandatory;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.products-scroll::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

.product-item {
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.brands-scroll {
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  scrollbar-width: none; /* Oculta scrollbar en Firefox */
  -ms-overflow-style: none; /* Oculta scrollbar en Edge */
}

.brands-scroll::-webkit-scrollbar {
  display: none; /* Oculta scrollbar en Chrome/Safari */
}

.brands-inner {
  display: flex;

  animation: scrollLeft 25s linear infinite;
}


.brand-item img {
  width: 80%;
  height: auto;
  object-fit: contain;
  border: none;
  box-shadow: none;
}

/* Animación opcional para desplazamiento automático */
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

</style>
